import { TASK_ITEMS_CRUD_ACTION_CREATORS } from '../actions/task_items_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { getBackendUri } from '../utils/EnvConfigUtils';
import FetchUtils from './fetch_utils';
import { parseJSON } from './fetch_utils';
import { logoutSuccess } from '../actions/session_actions';

const fetchUtils = new FetchUtils();

export const taskItemsRestCrudThunksForBuyer = new RestCrudThunks(
	'task_items',
	'task_item',
	'taskItem',
	'taskItems',
	TASK_ITEMS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'work_order/'
);
export const taskItemsRestCrudThunksForSupplier = new RestCrudThunks(
	'task_items',
	'task_item',
	'taskItem',
	'taskItems',
	TASK_ITEMS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'work_order/'
);

export const updateTasksBulk = (roleType) => (data) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/work_order/task_items/bulk`;

	// if sorting present, fix order naming and add to query params

	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(TASK_ITEMS_CRUD_ACTION_CREATORS.updateStart({}));

			fetchUtils
				.put(
					baseUrl + apiUrl,
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data,
					})
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(TASK_ITEMS_CRUD_ACTION_CREATORS.updateError(d.message, {}));
						reject(d.message);
					} else {
						dispatch(TASK_ITEMS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(TASK_ITEMS_CRUD_ACTION_CREATORS.updateError(d.message, {}));
					reject(d.message);
				});
		});
	};
};

export const deleteTasksBulk = (roleType) => (data) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/work_order/task_items/delete_multiple/${data
		.map((_) => _.id)
		.join(',')}`;

	// if sorting present, fix order naming and add to query params

	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(TASK_ITEMS_CRUD_ACTION_CREATORS.deleteStart({}));

			fetchUtils
				.delete(
					baseUrl + apiUrl,
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					})
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(TASK_ITEMS_CRUD_ACTION_CREATORS.deleteError(d.message, {}));
						reject(d.message);
					} else {
						dispatch(TASK_ITEMS_CRUD_ACTION_CREATORS.deleteSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(TASK_ITEMS_CRUD_ACTION_CREATORS.deleteError(d.message, {}));
					reject(d.message);
				});
		});
	};
};
